import { useMemo } from 'react';
import { useAuth } from '../auth/AuthProvider.tsx';
import { SpotifyClient } from './client.ts';

/** Liefert einen an die aktuelle Anmeldung gebundenen API-Client. */
export function useSpotifyClient(): SpotifyClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => new SpotifyClient(getAccessToken), [getAccessToken]);
}
